import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import videojs from 'video.js';

import TextField from '@mui/material/TextField';

import classes from './SearchInLesson.module.css';

let textToShow = [];

const SearchInLesson = props => {
  const myPlayer = videojs('lessonCourse');
  const [search, setSearch] = useState('');

  useEffect(() => {
    textToShow = [];
    if (search) {
      props.searchTexts.map(text => {
        let result = text.texto.search(new RegExp(search, 'i'));
        if (result > -1) {
          let textToAdd = {};
          if (search.trim().length > 0) {
            textToAdd.start = text.start;
            textToAdd.texto = `${text.texto}`;
          }
          textToShow.push(textToAdd);
        }
      });
    }
  }, [search]);

  const handleChangeSearch = event => {
    setSearch(event.target.value);
  };

  const goToOnVideo = time => () => {
    let numberTime = (time / 1000).toFixed(1);
    numberTime = numberTime.split('.');
    myPlayer.currentTime(
      numberTime[0] == 0 ? parseInt(1) : parseInt(time / 1000)
    );
  };

  const padToTwoDigits = num => {
    return num.toString().padStart(2, '0');
  };

  const convertMsToHHMMSS = ms => {
    let seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;

    seconds = padToTwoDigits(seconds);
    minutes = padToTwoDigits(minutes);
    hours = padToTwoDigits(hours);

    return `${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className={classes.searchLessonContainer}>
      <TextField
        id="SearchByLesson"
        label="Busqueda"
        className={classes.textField}
        value={search}
        onChange={handleChangeSearch}
        multiline
        rows="2"
        margin="normal"
        variant="outlined"
      />
      {!search
        ? props.searchTexts.map(text => (
            <p
              key={text.id}
              className={
                props.playerTime * 1000 >= text.start &&
                props.playerTime * 1000 < text.finish
                  ? classes.searchTextSelected
                  : classes.searchText
              }
              onClick={goToOnVideo(text.start)}
            >
              {convertMsToHHMMSS(text.start)} {'-->'} {text.texto}
            </p>
          ))
        : textToShow.map(text => {
            return (
              <p
                key={text.id}
                className={classes.searchText}
                onClick={goToOnVideo(text.start)}
              >
                {convertMsToHHMMSS(text.start)} {'-->'} {text.texto}
              </p>
            );
          })}
    </div>
  );
};

SearchInLesson.propTypes = {
  // eslint-disable-next-line react/require-default-props
  searchTexts: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  playerTime: PropTypes.number
};

export default SearchInLesson;
